var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { useMutation } from '@apollo/client';
import mutation from './index.graphql';
import { ReviewPaymentView } from './View';
import { useUser } from '../../../../../../context';
import { PaymentMethodType, getSelectedPaymentMethod, } from '../../../../../../utils/getSelectedPaymentMethod';
export var ReviewPaymentContainer = function (_a) {
    var paymentOption = _a.paymentOption, paymentMethod = _a.paymentMethod, paymentAmount = _a.paymentAmount, invoices = _a.invoices, onContinue = _a.onContinue;
    var account = useUser().account;
    var _b = __read(useMutation(mutation), 2), makePayment = _b[0], loading = _b[1].loading;
    var handlePayment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, makePayment({
                            variables: {
                                input: {
                                    accountId: account === null || account === void 0 ? void 0 : account.id,
                                    paymentMethodId: (_a = getSelectedPaymentMethod(paymentMethod, PaymentMethodType.primary)) === null || _a === void 0 ? void 0 : _a.paymentMethodId,
                                    paymentAmount: paymentAmount,
                                    invoices: invoices.map(function (i) { return ({
                                        invoiceId: i.invoiceId,
                                    }); }),
                                },
                            },
                        })];
                case 1:
                    data = (_c.sent()).data;
                    onContinue((_b = data === null || data === void 0 ? void 0 : data.payInvoices) === null || _b === void 0 ? void 0 : _b.paymentId);
                    return [3, 3];
                case 2:
                    e_1 = _c.sent();
                    console.error('Error: ', JSON.stringify(e_1));
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    return (React.createElement(ReviewPaymentView, { paymentOption: paymentOption, paymentMethod: paymentMethod, paymentAmount: paymentAmount, loading: loading, handlePayment: handlePayment }));
};
